export enum FormButtonType {
    Button = 'button',
    Submit = 'submit',
    Reset = 'reset'
}
